import { AppError } from "./app-error";
import { ERROR_CODES } from "./codes";
import { HTTP_STATUS } from "./http-status";

/**
 * 错误工厂函数
 *
 * 统一的错误创建入口，合并了原 createError 和 authorization 的工厂函数
 */
export const createError = {
  // =========================================================================
  // 认证错误 (401)
  // =========================================================================

  /**
   * 未认证错误 - 用户未登录
   */
  unauthenticated: (message = "请先登录", details?: unknown) =>
    new AppError(message, ERROR_CODES.UNAUTHENTICATED, HTTP_STATUS.UNAUTHORIZED, details),

  // =========================================================================
  // 授权错误 (403)
  // =========================================================================

  /**
   * 权限不足错误
   */
  forbidden: (message = "权限不足", details?: unknown) =>
    new AppError(message, ERROR_CODES.FORBIDDEN, HTTP_STATUS.FORBIDDEN, details),

  /**
   * 账号被禁用错误
   */
  accountDisabled: (message = "账号已被禁用") =>
    new AppError(message, ERROR_CODES.ACCOUNT_DISABLED, HTTP_STATUS.FORBIDDEN),

  /**
   * 角色无效错误
   */
  invalidRole: (message = "角色无效", details?: unknown) =>
    new AppError(message, ERROR_CODES.INVALID_ROLE, HTTP_STATUS.FORBIDDEN, details),

  /**
   * 缺少员工ID错误
   */
  missingStaffId: (message = "缺少员工ID") =>
    new AppError(message, ERROR_CODES.MISSING_STAFF_ID, HTTP_STATUS.FORBIDDEN),

  // =========================================================================
  // 验证错误 (400)
  // =========================================================================

  /**
   * 验证错误
   */
  validation: (message = "Validation error", details?: unknown) =>
    new AppError(message, ERROR_CODES.VALIDATION_ERROR, HTTP_STATUS.BAD_REQUEST, details),

  // =========================================================================
  // 资源错误 (404)
  // =========================================================================

  /**
   * 资源未找到错误
   */
  notFound: (message = "Resource not found", details?: unknown) =>
    new AppError(message, ERROR_CODES.NOT_FOUND, HTTP_STATUS.NOT_FOUND, details),

  // =========================================================================
  // 服务器错误 (500)
  // =========================================================================

  /**
   * 内部服务器错误
   */
  internal: (message = "Internal server error", details?: unknown) =>
    new AppError(
      message,
      ERROR_CODES.INTERNAL_SERVER_ERROR,
      HTTP_STATUS.INTERNAL_SERVER_ERROR,
      details,
      false, // Not operational - unexpected errors
    ),

  externalService: (message = "外部服务错误", details?: unknown) =>
    new AppError(
      message,
      ERROR_CODES.EXTERNAL_SERVICE_ERROR,
      HTTP_STATUS.BAD_GATEWAY,
      details,
      false,
    ),

  /**
   * 数据库错误
   */
  database: (message = "Database error", details?: unknown) =>
    new AppError(
      message,
      ERROR_CODES.DATABASE_ERROR,
      HTTP_STATUS.INTERNAL_SERVER_ERROR,
      details,
      false,
    ),

  // =========================================================================
  // 业务逻辑错误 (422)
  // =========================================================================

  /**
   * 业务规则违反错误
   */
  businessRule: (message: string, details?: unknown) =>
    new AppError(
      message,
      ERROR_CODES.BUSINESS_RULE_VIOLATION,
      HTTP_STATUS.UNPROCESSABLE_ENTITY,
      details,
    ),
};
